/*
 * @Author: wq
 * @Date: 2020-07-14 15:53:35
 */ 
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    // backstageUrl: 'http://liancan-admin.mmdiandi.com', // 线上-后台域名
    // bidDataUrl: 'http://liancan-data.mmdiandi.com/#/', // 线上-大数据云屏
    backstageUrl: 'https://account.liancanjd.com', // 线上-后台域名
    // backstageUrl: 'http://liancan-cloud.liancanjd.com/', //微服务-后台域名


    // backstageUrl: 'http://liancan-test-admin.mmdiandi.com', // 测试环境-后台域名
    bidDataUrl: 'http://liancan-data-test.mmdiandi.com/#/', // 测试环境-大数据云屏
    
  },
  mutations: {
    set_token(state, token){
      state.token = token;
      sessionStorage.token = token
    }

  },
  actions: {
  },
  modules: {
  }
})


// WEBPACK FOOTER //
// ./src/vuex/store.js